import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
const AccountListItem = styled((props) => _jsx(Typography, Object.assign({ component: 'li' }, props)))(({ theme }) => ({
    '&::marker': {
        content: '""',
    },
    '&:before': {
        content: '"-"',
        position: 'absolute',
        width: '1rem',
        marginLeft: '-1rem',
        fontWeight: 'bold',
    },
}));
export default AccountListItem;
